import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlaceholder: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="placeholder, generate"><path d="M3.75 6.25V3.75H6.25M17.75 3.75H20.25V6.25M20.25 17.75V20.25H17.75M6.25 20.25H3.75V17.75M3.75 13.75V10.25M10.25 3.75H13.75M20.25 10.25V13.75M13.75 20.25H10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPlaceholder;
